import React from 'react';
import PropTypes from 'prop-types';
import { fetchCampaignAccumulated } from 'store/actions/campaigns/fetchCampaigns';
import SingleDataContainer from 'containers/Data/SingleDataContainer';
import utils from 'helpers/utils';

class CampaignField extends React.Component {
    render() {
        const { display, record, source, style } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        return (
            <span style={ style }>
                <SingleDataContainer
                    action={ fetchCampaignAccumulated }
                    id={ record[source] }
                    resource='campaigns'
                >
                    { (renderProps) => {
                        const { data } = renderProps;

                        return (
                            <span>{ data[display] }</span>
                        );
                    } }
                </SingleDataContainer>
            </span>
        );
    }
}

CampaignField.propTypes = {
    display: PropTypes.string.isRequired,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    style: PropTypes.object,
};

export default CampaignField;



// WEBPACK FOOTER //
// ./src/components/field/CampaignField.js